import { render, staticRenderFns } from "./ViewLinks.vue?vue&type=template&id=f1256788&"
import script from "./ViewLinks.vue?vue&type=script&lang=js&"
export * from "./ViewLinks.vue?vue&type=script&lang=js&"
import style0 from "./ViewLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports